import create from 'zustand'

export const useModalStore = create((set) => ({
  modalShow: false,
  setModalShow: (x) => set(() => ({ modalShow: x })),
}))
export const useContentStore = create((set) => ({
  content: '',
  setContent: (x) => set(() => ({ content: x })),
}))
export const useTicketStore = create((set) => ({
  ticket: 0,
  setTicket: (x) => set(() => ({ ticket: x })),
}))